import React from 'react';
import { useForm } from "react-hook-form";
import { InputLabel } from '@material-ui/core';
import * as firebase from "firebase/app";
import "firebase/auth";
import { Link } from 'react-router-dom';
import Google from '../Google/Google';
import Facebook from '../Facebook/Facebook';
import './Create.css';


const Create = () => {
    const { register, handleSubmit, errors } = useForm();
    const onSubmit = data => {
        console.log(data);
        const { email, password } = data;
        firebase.auth().createUserWithEmailAndPassword(email, password)
            .catch(error => {
                console.log(error.message);
                console.log(error.code);
            });
    };

    return (
        <div className="container" >
            <div className="d-flex justify-content-center">
                <form onSubmit={handleSubmit(onSubmit)} style={{color:'black'}} className="box2">
                    <InputLabel htmlFor="origin" style={{color:'black'}}>Full Name</InputLabel>
                    <input placeholder="Full Name" name="nameRequired" ref={register({ required: true })} />
                    {errors.nameRequired && <span className="text-danger">Name is required</span>}
                    <br />
                    <br />
                    <InputLabel htmlFor="email" style={{color:'black'}}>Email</InputLabel>
                    <input placeholder="Email Address" type="email" name="emailRequired" ref={register({ required: true })} />
                    {errors.emailRequired && <span className="text-danger">Email is required</span>}
                    <br />
                    <br />
                    <InputLabel htmlFor="password" style={{color:'black'}}>Password</InputLabel>
                    <input placeholder="Password" type="password" name="passwordRequired" ref={register({ required: true })} />
                    {errors.passwordRequired && <span className="text-danger">Password is required</span>}
                    <br />
                    <input className="btn btn-warning mt-3" type="submit" value="Create an account" />
                    <p>Already have an account? <Link className="text-warning text-decoration-none" to="/login"> <span style={{color:'red'}}> Login</span>  </Link></p>
                </form>
            </div>
            <div className="d-flex justify-content-center" style={{marginTop:'20px'}}>
                <Google />
            </div>
            <br />
            <div className="d-flex justify-content-center">
                <Facebook />
            </div>
        </div>
    );
}

export default Create;